import { useEffect } from 'react';

/* Loads the UserWay accessibility widget when REACT_APP_USERWAY_ACCOUNT is set. */
export default function UserWayWidget() {
  useEffect(() => {
    const account = process.env.REACT_APP_USERWAY_ACCOUNT;
    if (!account || document.getElementById('userway-script')) return;
    const s = document.createElement('script');
    s.id = 'userway-script';
    s.src = 'https://cdn.userway.org/widget.js';
    s.async = true;
    s.setAttribute('data-account', account);
    s.setAttribute('data-widget_layout', 'full');
    s.setAttribute('data-statement_text', 'Our Accessibility Statement');
    s.setAttribute('data-statement_url', `${window.location.origin}/accessibility`);
    s.setAttribute('data-position', '3');
    document.body.appendChild(s);
    const css = document.createElement('style');
    css.id = 'userway-offset-css';
    css.textContent = `
      .uwy .userway_buttons_wrapper { bottom: 26px !important; left: 12px !important; right: auto !important; top: auto !important; }
      @media (min-width: 640px) { .uwy .userway_buttons_wrapper { bottom: 28px !important; left: 16px !important; } }
    `;
    document.head.appendChild(css);
  }, []);
  return null;
}
